// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--2dihn","title":"dd31006766--title--2dYU5"};